"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var Anchor = function Anchor(props) {
  var getRelValue = function getRelValue() {
    if (props.target !== '_blank') {
      return props.rel;
    }

    return props.rel ? "".concat(props.rel, " noopener noreferrer") : 'noopener noreferrer';
  };

  return /*#__PURE__*/React.createElement("a", (0, _extends2["default"])({}, props, {
    rel: getRelValue()
  }), props.children);
};

Anchor.defaultProps = {
  href: '#',
  tabIndex: 0
};
var _default = Anchor;
exports["default"] = _default;